import window from './window';
import $ from 'jquery';
import 'slick-carousel';

export default () => {

  window.addEventListener('DOMContentLoaded', () => {
    
  });

  $(() => {
    
    // jQuery Code Here

    /**
     * Slick Carousel
     */
    if ($('.hero__slider').length) {
      $('.hero__slider').slick({
        dots: true,
        lazyLoad: 'ondemand',
        centerMode: true,
        focusOnSelect: true
      });
      $('.hero__slider').on('beforeChange', slick => {
        $('.hero__slider').find('.is-loading').not('.is-loaded').addClass('is-loaded');
      });
    }
    if ($('.hero__slider--sp').length) {
      $('.hero__slider--sp').slick({
        dots: true,
        lazyLoad: 'ondemand',
        adaptiveHeight: true
      });
      $('.hero__slider--sp').on('beforeChange', slick => {
        $('.hero__slider--sp').find('.is-loading').not('.is-loaded').addClass('is-loaded');
      });
    }
    $('.RelatedArticle__list').each(function () {
      const $RelatedArticle__list = $(this);
      if ($(window).width() > 768 && $RelatedArticle__list.find('.RelatedArticle__item').length > 4) {
        $RelatedArticle__list.slick({
          dots: false,
          lazyLoad: 'ondemand',
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 5,
          slidesToScroll: 1
        });
        $RelatedArticle__list.on('beforeChange', slick => {
          $RelatedArticle__list.find('.is-loading').not('.is-loaded').addClass('is-loaded');
        });
        $(this).addClass('addCenter');
      } else if ($(window).width() <= 768 && $RelatedArticle__list.find('.RelatedArticle__item').length > 2) {
        $RelatedArticle__list.slick({
          autoplay: true,
          autoplaySpeed: 3000,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          centerMode: true,
          variableWidth: true,
          centerPadding: '10%'
        });
        $RelatedArticle__list.on('beforeChange', slick => {
          $RelatedArticle__list.find('.is-loading').not('.is-loaded').addClass('is-loaded');
        });
        $(this).addClass('addCenter');
      }
    });

    if ($('.article__content h4').length) {
      $('.article__content h4').each(function () {
        $(this).wrapInner('<span>');
      });
    }
    if ($('.article__content  li:not(.article__tocItem)').length) {
      $('.article__content  li:not(.article__tocItem)').each(function () {
        $(this).wrapInner('<span>');
      });
    }

    /**
     * header submenu
     */
    $('.js-l-navi__linkmore').each(function(){
      $(this).on('click',function(){
        var _this = this;
        $("+.subcategory__list", _this).toggleClass('openSubmenu');
        $(_this).toggleClass('js-open');
        
        return false;
      });
    });

    /**
     * fixed banner
     */
    if(!sessionStorage.getItem("is-visited")) {
      $(".fixedbn").removeClass('closebanner');
      sessionStorage.setItem("is-visited", 'true');
    }

    $('.close').each(function(){
      $(this).on('click',function(){
        $(this).parent(".fixedbn").addClass('closebanner');
      });
    });

  }); 

}